import { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/routers/constant'

const router: Array<RouteRecordRaw> = [
  {
    path: '/system/param',
    component: Layout,
    redirect: '/system/param/index',
    meta: {
      title: '参数管理',
      keepAlive: true,
      requiresAuth: true
    },
    children: [
      {
        path: 'index',
        name: 'SystemParamIndex',
        component: () => import('@/views/system/param/index.vue'),
        meta: {
          keepAlive: true,
          requiresAuth: true,
          title: '参数管理'
        }
      }
    ]
  }
]

export default router
